<template>
  <div class="vlt-share">
    <div class="vlt-share-contain">
      <button
        type="button"
        class="vlt-btn-ico primary share-icon"
        @click="() => togglePopup(showPopup ? false : true)"
      >
        <img :src="imgUrl" alt="share icon" />
        <p
          class="share-tag"
          :style="{
            color: color === 'BLACK' ? '#000000' : 'FFFFFF'
          }"
        >
          Share
        </p>
      </button>

      <div class="share-popup" v-show="showPopup">
        <div class="share-box">
          <ul>
            <li @click="shareFbCB">
              <img
                src="@/assets/icons/facebook-48.png"
                class="share-ico"
                alt="fb icon"
              />
            </li>
            <li>
              <a
                target="_blank"
                :href="twitterShareUrl"
                id="twitter-button"
                @click="shareTwCB()"
              >
                <img
                  src="@/assets/icons/twitter-52.png"
                  class="share-ico"
                  alt="gp icon"
                />
              </a>
            </li>
            <li>
              <a
                class="custom-link"
                :data-clipboard-text="link"
                target="_blank"
                @click="shareCount('OTHERS')"
              >
                <img
                  src="@/assets/icons/link-52.png"
                  class="share-ico"
                  alt="tw icon"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="share-overlay"
      v-show="showPopup"
      @click="() => togglePopup(false)"
    ></div>
  </div>
</template>

<script>
import Content from "@/mixins/Content";
import snackbar from "node-snackbar";
import "nm/node-snackbar/dist/snackbar.css";
import ClipboardJS from "clipboard";

export default {
  name: "Share",
  props: ["content", "color"],
  data() {
    return {
      showPopup: false,
      twitterShareUrl: undefined,
      gplusShareUrl: undefined,
      link: null,
      clipboard: undefined,
      imgUrl: require("@/assets/icons/share-96.png")
    };
  },
  created() {
    this.createLink();
    this.initShare();
    if (this.color === "BLACK") {
      this.imgUrl = require("@/assets/icons/Ic_share.svg");
    }
  },
  watch: {
    content() {
      this.createLink();
    }
  },
  beforeDestroy() {
    this.clipboard.destroy();
  },
  methods: {
    shareCount(medium) {
      // console.log("medium&Content", this.content, medium);
      this.vLiveSDKContentShare(this.content, medium);
    },
    createLink() {
      if (this.clipboard) {
        this.clipboard.destroy();
      }
      
      let hostname = window.location.host

      if (hostname.includes('www.')) {
        hostname = hostname.replace('www.', '');
      }
      
      // console.log('hostname===', hostname)

      // this.link = `https://${window.location.host}/content?contentid=${this.content.contentid}`;
      this.link = `https://${hostname}/content?contentid=${this.content.contentid}`;
      this.clipboard = new ClipboardJS(".custom-link");
      this.clipboard.on("success", function(e) {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        // Show the snackbar message
        snackbar.show({ text: "Link Generated", pos: "bottom-center" });
        e.clearSelection();
      });
      this.clipboard.on("error", function(e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
      });
    },
    initShare() {
      // console.log('[Share initShare content]', this.content);

      if (!this.content) return;
      // Creating the twitter share URL
      this.twitterShareUrl =
        "https://twitter.com/share?url=" +
        encodeURIComponent(window.location.href);
      // let image = this.getPoster(this.content);
      // this.twitterShareUrl = 'https://twitter.com/share?'+'text=Watch ' + this.content.title + ' on SDG'+'&url=' + image;
      // console.log("twitter>>",image)
      // console.log("url>>", this.twitterShareUrl);
      // Creating the Google Plus share URL
      this.gplusShareUrl = `https://plus.google.com/share?url=${encodeURIComponent(
        window.location.href
      )}`;
    },
    togglePopup(state) {
      this.showPopup = state;
    },
    getPoster(content) {
      if (content.posters.length) {
        let landscapeposters = content.posters.filter(
          pos => pos.orientation === "PORTRAIT"
        );
        if (landscapeposters.length) {
          let posterIndex = landscapeposters.findIndex(
            pos => pos.quality === "HD"
          );
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    },
    shareFbCB() {
      this.vLiveSDKContentShare(this.content, "FACEBOOK");
      // Get the URL to be shared
      let link = window.location.href;
      // Get the image to be shown on the feed
      let image = this.getPoster(this.content);
      // Get the title to be shown on the feed
      let title = `Watch ${this.content.title} on SDG`;
      // Get the description to be shown on the feed
      let description = this.content.description;

      // Initialize Share
      FB.ui(
        {
          method: "share_open_graph",
          action_type: "og.shares",
          action_properties: JSON.stringify({
            object: {
              "og:url": window.location.href,
              "og:title": title,
              "og:description": description,
              "og:image": image
            }
          })
        },
        response => {
          // console.log('[shareFbCB response]', response);
        }
      );
    },
    shareGpCB() {
      // console.log('[shareGpCB]');
    },
    shareTwCB() {
      this.vLiveSDKContentShare(this.content, "TWITTER");
      let image = this.getPoster(this.content);
      //        <meta name="twitter:card" content="summary" />
      // <meta name="twitter:site" content="@flickr" />
      // <meta name="twitter:title" content="Small Island Developing States Photo Submission" />
      // <meta name="twitter:description" content="View the album on Flickr." />
      // <meta name="twitter:image" content="https://farm6.staticflickr.com/5510/14338202952_93595258ff_z.jpg" />
      let linkTag = document.getElementsByTagName("link")[0];
      let summary = "";
      summary = document.createElement("meta");
      summary.name = "twitter:card";
      summary.content = "summary";
      document.head.insertBefore(summary, linkTag);

      let twttrSite = "";
      twttrSite = document.createElement("meta");
      twttrSite.name = "twitter:site";
      twttrSite.content = "@SDG";
      document.head.insertBefore(twttrSite, linkTag);

      let ogUrl = "";
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      ogUrl.content =
        "http://bits.blogs.nytimes.com/2011/12/08/a-twitter-for-my-sister/";
      document.head.insertBefore(ogUrl, linkTag);

      let twttrTitle = "";
      twttrTitle = document.createElement("meta");
      twttrTitle.setAttribute("property", "og:title");
      twttrTitle.content = this.content.title;
      document.head.insertBefore(twttrTitle, linkTag);

      let twttrImg = "";
      twttrImg = document.createElement("meta");
      twttrImg.setAttribute("property", "og:image");
      twttrImg.content = image;
      document.head.insertBefore(twttrImg, linkTag);
    }
  },
  mixins: [Content]
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/components";

// Top element styles are defined where the component is being declared
.vlt-share-contain {
  position: relative;
  z-index: 89;
  .share-popup {
    position: absolute;
    background-color: #e6e6e6;
    padding: 2px 8px;
    width: 210px;
    border-radius: 40px;
    top: 0px;
    left: 100%;
    transition: 0.5s;
    // right: calc(100% - 26px);
    // top: 130%;
    // box-shadow: 0px 1px 6px 0px #d0d0d0;
    ul {
      text-align: center;
      li {
        display: inline-block;
        margin-right: 15px;
        cursor: pointer;

        img {
          width: 40px;
          padding: 8px;
          vertical-align: middle;
          // background-color: #b9b9b9;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .vlt-btn-ico {
    cursor: pointer;
  }
}
.share-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: red;
  z-index: 88;
}
.share-icon {
  padding-top: 0;
  img {
    width: 30px;
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 576px) {
  .share-icon {
    padding-top: 0;
    img {
      // width: 18px;
    }
  }
  .vlt-share-contain {
    .share-popup {
      width: 35px;
      margin-left: 10px;
      border-radius: 20px;
      position: absolute;
      background-color: #e6e6e6;
      padding: 5px;
      top: 0px;
      left: 100%;
      transition: 0.5s;
      text-align: center;
      // left: -175%;
      ul {
        li {
          margin-right: 7px;
          display: block;
          img {
            width: 25px;
            padding: 5px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .share-icon {
    padding-top: 0;
    img {
      // width: 18px;
    }
  }
  .vlt-share-contain {
    .share-popup {
      width: 35px;
      margin-left: 10px;
      border-radius: 20px;
      position: absolute;
      background-color: #e6e6e6;
      padding: 5px;
      top: 0px;
      left: 50%;
      transition: 0.5s;
      text-align: center;
      // left: -175%;
      ul {
        li {
          margin-right: 7px;
          display: block;
          img {
            width: 25px;
            padding: 5px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.share-tag {
  color: #ffffff;
  font-family: "ProximanovaRegular";
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
}
// 4k
@media screen and (min-width: 1900px) {
  .share-icon {
    padding-top: 0;
    img {
      width: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slots/share.vue